import {Configuration as ConfigurationType} from './Configuration.d';

export const Configuration: ConfigurationType = {
    API: {
        BaseUrl: process.env.VUE_APP_API_BASE_UR
    },
    OpenIdConnect: {
        ClientId: process.env.VUE_APP_CLIENT_ID,
        RequestScope: process.env.VUE_APP_REQUEST_SCOPE,
        TenantId: process.env.VUE_APP_TENANT_ID,
        RedirectUrl: process.env.VUE_APP_API_REDIRECT_URL
    },
    Version: process.env.VUE_APP_VERSION_NUMBER,
    FeatureToggle: {
        FinancialServices: process.env.VUE_APP_FEATURE_TOGGLE_FINANCIAL_SERVICES,
        Titles: process.env.VUE_APP_FEATURE_TOGGLE_TITLES
    }
}
